"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./client"), exports);
__exportStar(require("./fetch-handler"), exports);
__exportStar(require("./types"), exports);
__exportStar(require("./util"), exports);
__exportStar(require("./xrpc-client"), exports);
/* eslint-disable import/no-deprecated */
const client_1 = require("./client");
/** @deprecated create a local {@link XrpcClient} instance instead */
const defaultInst = new client_1.Client();
exports.default = defaultInst;
/* eslint-enable import/no-deprecated */
//# sourceMappingURL=index.js.map